import { render, staticRenderFns } from "./dynamic-public.vue?vue&type=template&id=74d8226a&scoped=true&"
import script from "./dynamic-public.vue?vue&type=script&lang=js&"
export * from "./dynamic-public.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-public.vue?vue&type=style&index=0&id=74d8226a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d8226a",
  null
  
)

export default component.exports